<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5><i class="fa fa-fw fa-flag mr-2" />Users</h5>
            <hr />
            <div class="search-wrapper d-flex align-items-center justify-content-between">
                <b-form-group
                    label="Filter"
                    label-for="filterInput"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex search-input-wrapper">
                        <b-form-input class="ml-2 mr-2"
                            v-model="input.filter"
                            type="search"
                            id="filterInput"
                            placeholder="Nama / Role"
                        />
                    </div>
                </b-form-group>
                <b-button class="mb-3" variant="primary" @click="$bvModal.show('modal-input')">Input User Baru</b-button>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="items"
                :fields="fields"
                responsive class="mb-3"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="input.filter"
                @filtered="onFiltered"
            >
                <template v-slot:empty>
                    Tidak ada user.
                </template>
                <template v-slot:cell(role)="row">
                    <b-badge :variant="parseRoleBadge(row.item.role.id)">
                        {{ row.item.role.name }}
                    </b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <b-button class="mr-2" size="sm" variant="primary" v-b-tooltip.hover.top title="Edit" @click="openEditModal(row.item)">
                        <i class="fa fa-fw fa-pencil" />
                    </b-button>
                    <b-button size="sm" variant="warning" v-b-tooltip.hover.top title="Reset Password" @click="openResetModal(row.item)">
                        <i class="fa fa-fw fa-refresh" />
                    </b-button>
                </template>
            </b-table>
            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" />
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :totalRows="totalRows"
                    :per-page="perPage"
                />
            </div>
        </b-card>
        <b-modal id="modal-input" title="Input User Baru"
            centered no-close-on-backdrop hide-footer
            @shown="$refs.inputName.focus()"
        >
            <b-form-group label="Username">
                <b-form-input ref="inputName" v-model="input.username" />
            </b-form-group>
            <b-form-group label="Nama Lengkap">
                <b-form-input v-model="input.fullname" />
            </b-form-group>
            <b-form-group label="Role">
                <b-form-select v-model="input.role" :options="optRole" />
            </b-form-group>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executeInput">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="modal-edit" title="Edit User"
            centered no-close-on-backdrop hide-footer
            @shown="$refs.editName.focus()"
        >
            <b-form-group label="Username">
                <b-form-input ref="editName" v-model="edit.username" />
            </b-form-group>
            <b-form-group label="Nama Lengkap">
                <b-form-input v-model="edit.fullname" />
            </b-form-group>
            <b-form-group label="Role">
                <b-form-select v-model="edit.role" :options="optRole" />
            </b-form-group>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executeEdit">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="modal-reset" title="Reset Password"
            centered no-close-on-backdrop hide-footer
        >
            Reset password untuk user {{ activeItem.fullname }}? Password akan direset menjadi <b>123456</b>!
            <div class="text-right mt-3">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executeReset">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Memproses...' : 'Ya' }}
                </b-btn>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'wilayah',
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            input: {
                username: "",
                fullname: "",
                role: 1
            },

            edit: {
                username: "",
                fullname: "",
                role: 0
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "fullname", label: "Nama User", sortable: true },
                { key: "username", label: "Username", sortable: true },
                { key: "role", label: "Role" },
                { key: "action", label: "Aksi"},
            ],

            items: [],
            activeItem: { fullname: "" },
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,

            optRole: [
                { value: 1, text: "Staff" },
                { value: 2, text: "Buyer" }
            ]

        }
    },

    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            Promise.all([getItems]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        getItems() {

            let query = ""

            this.isBusy = true
            this.items = []

            return this.$axios.get("user/").then(res => {

                this.items = res.data
                this.totalRows = res.data.length

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        executeInput() {

            if(this.$helper.isBlank(this.input.username)) {
                return this.$helper.toastError(this, "Username tidak boleh kosong!")
            }

            if(this.$helper.isBlank(this.input.fullname)) {
                return this.$helper.toastError(this, "Nama lengkap tidak boleh kosong!")
            }

            let payload = new FormData()
            payload.append("username", this.input.username)
            payload.append("fullname", this.input.fullname)
            payload.append("role", this.input.role)

            this.isSubmitting = true
            this.$axios.post("user/", payload).then(res => {

                this.items.push(res.data)
                this.totalRows++

                this.$bvModal.hide("modal-input")
                this.$helper.toastSuccess(this, "User baru berhasil ditambahkan!")

                this.input.username = ""
                this.input.fullname = ""
                this.input.role = 0

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        executeEdit() {

            if(this.$helper.isBlank(this.edit.username)) {
                return this.$helper.toastError(this, "Username tidak boleh kosong!")
            }

            if(this.$helper.isBlank(this.edit.fullname)) {
                return this.$helper.toastError(this, "Nama lengkap tidak boleh kosong!")
            }

            let payload = new FormData()
            payload.append("userId", this.activeItem.id)
            payload.append("username", this.edit.username)
            payload.append("fullname", this.edit.fullname)
            payload.append("role", this.edit.role)

            this.isSubmitting = true
            this.$axios.post("user/edit", payload).then(res => {

                this.activeItem.username = res.data.username
                this.activeItem.fullname = res.data.fullname
                this.activeItem.role = res.data.role

                this.$bvModal.hide("modal-edit")
                this.$helper.toastSuccess(this, "User berhasil diubah!")

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        executeReset() {

            let payload = new FormData()
            payload.append("userId", this.activeItem.id)

            this.isSubmitting = true
            this.$axios.post("user/reset-password", payload).then(res => {

                this.$bvModal.hide("modal-reset")
                this.$helper.toastSuccess(this, "Password user berhasil direset ke 123456!")

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        openEditModal(item) {

            this.activeItem = item
            this.edit.username = item.username
            this.edit.fullname = item.fullname
            this.edit.role = item.role.id

            this.$bvModal.show("modal-edit")

        },

        openResetModal(item) {

            this.activeItem = item
            this.$bvModal.show("modal-reset")

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },

        parseRoleBadge(id) {

            switch(id) {
                case 1: return "success"
                case 2: return "primary"
                default: return "-"
            }

        }

    },

    created(){
        this.init()
    }
}
</script>
